/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * When a kind's steps timed from its event happen, measured from it: the
 * choice's name, its unit, before (sign -1) or after (1), and the limits
 * of its value. changes_while_on: false when it changes only while off.
 */
export type TimingInfo = {
  key: string;
  unit: TimingInfo.unit;
  sign: number;
  low: number;
  high: number;
  changes_while_on?: boolean;
};

export namespace TimingInfo {
  export enum unit {
    HOURS = "hours",
    DAYS = "days",
  }
}
